module.exports = __webpack_public_path__ + "img/ko_img2.0174e8a0.png";